module.exports = __webpack_public_path__ + "static_pc/img/13.49c07328.jpeg";